import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import { assignReasoningGapSession } from '../../service/reasoningGapService'

// Shared study link (/rg/:a/:b): sends each student to one of a Code/Thinking session pair,
// balanced by the server. The assignment is remembered in this browser so a reload or a
// second visit keeps the same group.
export default function ReasoningGapAssign () {
  const { a, b } = useParams()
  const key = `rg-assign:${a}:${b}`
  const [target, setTarget] = useState(() => {
    try { return localStorage.getItem(key) } catch (e) { return null }
  })
  const [error, setError] = useState('')

  useEffect(() => {
    if (target) return
    // /rg/12 (one number) used to render a blank page and looked like a broken link.
    if (!b) {
      setError('This quiz link is incomplete: it should end with two numbers, like vizpi.org/rg/12/13. Please ask your instructor for the full link.')
      return
    }
    assignReasoningGapSession(a, b)
      .then((id) => {
        try { localStorage.setItem(key, String(id)) } catch (e) { /* ignore */ }
        setTarget(String(id))
      })
      .catch(e => setError(e.response?.data?.error || 'Could not open this quiz link. Please try again.'))
  }, [a, b, key, target])

  if (target) return <Navigate to={`/session/${target}`} replace />
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', gap: 12 }}>
      {error ? <span>{error}</span> : <><CircularProgress size={22} /> <span>Opening your quiz…</span></>}
    </div>
  )
}
